export enum iconNames {
  COMMUNITY = 'community',
  QUESTION = 'question',
  DOWN = 'down',
  PLUS = 'plus',
  CALENDAR = 'calendar',
  GOTO = 'goto',
  LEFTARROW = 'LeftArow',
  RIGHT = 'Right',
  EDIT = 'Edit',
  QUESTIONGRAY = 'QuestionGray',
  LOGOWHITE = 'LogoWhite',
  EYE = 'Eye',
  EYEHIDE = 'EyeHide',
  USER = 'User',
  SIGNOUT = 'SignOut',
  UP = 'Up',
  LEFT = 'Left',
  HIDE = 'Hide',
  TOP = 'Top',
  BOT = 'Bot',
  TRASH = 'Trash',
  WARNING = 'Warning',
  EXCLUSIVE = 'Exclusive',
  CHECKLIST = 'Checklist',
  EXCLUSIVECIRCLE = 'ExclusiveCircle',
  CHECKBOXCIRCLE = 'CheckboxCricle',
  INFO = 'Info',
  DELETE = 'Delete',
  NAVIGATION = 'Navigation',
  EXIT = 'Exit',
  TIKTOK= 'Tiktok',
  YOUTUBE= 'Youtube',
  INSTAGRAM= 'Instagram',
  LINKEDIN= 'Linkedin',
  TWITTER= 'Twitter',
  WEBSITE= 'Website'
}
